import Button from "../button/button";
import Typography from "../typography/typography";
import "./reports-title-bar.scss";

import TitleDropdownButton from "../title-dropdown-button/title-dropdown-button";
import { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { generateFields } from "../../utils/common";
import ReportButtons, { IReportButtons } from "./report-buttons/report-buttons";
import TabBar, { TabProps } from "../tabs/tabs";
import { Box, ButtonGroup, ClickAwayListener, Grow, Menu, MenuItem, Paper, Popover, Popper, Button as MuiButton, Divider } from "@mui/material";
import images from "../../assets/images";
import {
  handleCompareDateRange,
  RANGE,
} from "../../utils/date-range";
import { DateRange, Calendar } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import dayjs from "dayjs";
import { useAppDispatch } from "../../redux/hooks";
import { fetchCompanies } from "./redux/actionCreator";
import SearchableSelect from "../searchable-select";
import Checkbox from "../checkbox/checkbox";
import { useTranslation } from "react-i18next";
import React from "react";
import { Calendar as CalendarIcon, Export as ExportIcon, Filter as FilterIcon } from "../icons";
import { enUS } from 'date-fns/locale';

interface IReportFilters {
  company: number;
  start_date: string;
  end_date: string;
  as_of_date: string;
}

/** Descriptor for a custom component injected into the filter row. */
interface ICustomFilterComponent {
  /** Unique key used for React reconciliation. */
  key: string;
  /** The ReactNode to render inside the filter bar. */
  component: React.ReactNode;
}

interface ActionBarPropsType extends Partial<TabProps>, IReportButtons {
  title: string;
  handleAddButton?: (e?: any) => void;
  isTitleMenu?: boolean;
  titleMenus?: any;
  reportFilterFields?: any[];
  isDateFilterEnabled?: boolean;
  onDateFilterChange?: (
    data: Partial<{
      company: string | number;
      start_date: string;
      end_date: string;
      as_of_date: string;
    }>
  ) => void;
  filters?: Partial<IReportFilters>;
  isDateRange?: boolean;
  /**
   * When `false` the Date chip and the date-range dropdown button are hidden
   * and date-related keys (`start_date`, `end_date`, `as_of_date`) are stripped
   * from every filter payload so they cannot reach the API.
   * Defaults to `true` (backward-compatible).
   */
  showDateFilter?: boolean;
  dateFilter?: string;
  showCancelButton?: boolean;
  searchBar?: React.ReactNode;
  /**
   * Optional list of custom components to render inside the filter row.
   * Each entry must have a unique `key` and a `component` (ReactNode).
   * They are appended after the standard SearchableSelect filters.
   */
  customFilterComponents?: ICustomFilterComponent[];
  autoShowFiltersWithValue?: boolean;
  defaultVisibleFilters?: { value: string }[];
}

type TDatePickerVal = {
  startDate?: Date;
  endDate?: Date;
  key?: string;
};

const ReportsTitleBar = (props: ActionBarPropsType) => {
  const {
    title,
    handleAddButton,
    buttons = [],
    dropdownMenuButtonData,
    isTitleMenu = false,
    titleMenus = [],
    reportFilterFields = [],
    toggleCallback,
    tabs,
    activeValue,
    setActiveValue,
    isDateFilterEnabled = true,
    onDateFilterChange,
    // showCancelButton,
    filters = {},
    isDateRange = false,
    /** Hide the date chip and date-range dropdown when false. Defaults to true. */
    showDateFilter = true,
    dateFilter = 'TODAY',
    filterDropDown,
    handleRowsCollapse,
    handleRowsExpand,
    showLevelBtn = false,
    dataLength = 0,
    filterKeys = {},
    searchBar,
    /** Custom ReactNode components rendered after the standard filters. */
    customFilterComponents = [],
    autoShowFiltersWithValue = false,
    defaultVisibleFilters = [],
  } = props;

  const startDateKey = filterKeys?.start_date || 'start_date';
  const endDateKey = filterKeys?.end_date || 'end_date';
  const asOfDateKey = filterKeys?.as_of_date || 'as_of_date';

  // const { companies } = useAppSelector((store) => store.reportsTitleBar);

  const dispatch = useAppDispatch();
  const customStyle =
  {

    '&.MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
        borderColor: `#ade7cb`,
        borderRadius: `25px`
      },
      '& .MuiSelect-outlined': {
        padding: `4.5px 14px !important`
      },
      // '&:hover fieldset': {
      //   border: 'none',
      // },

      // '&.Mui-focused fieldset': {
      //   border: 'none',
      // },
      display: `flex`,
      gap: `4px`,
      width: `220px`,
      // height: 30px,
      border: `1px solid #ade7cb`,
      borderRadius: `50px`,
      backgroundColor: `#ebf9f2`,
      color: `#289b64`,
      alignItems: `center`,
      cursor: `pointer`,
      height: `32px`

    },
  }
  const inputStyle =
  {
    border: "none",
    "&.Mui-focused": {
      borderColor: "transparent",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "0px",
      fontSize: "14px",
      color: '#289b64'
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    '& .MuiSelect-icon': {
      color: 'green',
    },
  }

  // When `showDateFilter` is false, exclude the 'date' entry from the
  // default selection so the date chip is never active.
  const defaultSelected = [
    // Only include 'date' when the date field matches legacy 'date' value if needed, 
    // but here we follow inventory-reports-title-bar pattern.
    ...(showDateFilter ? [{ value: 'date' }] : []),
    {
      value: 'company',
    },
    ...(defaultVisibleFilters || []),
  ]
  const [selectedItems, setSelectedItems] = useState<string[]>(defaultSelected);
  const [level, setLevel] = useState<number>(1)

  // const selectedCompany = useMemo(
  //   () =>
  //     companies?.find((company) => filters?.company === company.id)
  //       ?.company_name || "",
  //   [companies, filters?.company]
  // );


  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const [actionAnchorEl, setActionAnchorEl] = useState<null | HTMLElement>(null);
  const [appliedFiltersAnchorEl, setAppliedFiltersAnchorEl] = useState<null | HTMLElement>(null);
  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const [allFields, setAllFields] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState<keyof typeof RANGE>();
  const [open, setOpen] = useState<boolean>(false);
  const [exportAnchorEl, setExportAnchorEl] = useState<null | HTMLElement>(null);
  const [customDate, setCustomDate] = useState<Date>(
    dayjs(filters?.[asOfDateKey]).isValid()
      ? dayjs(filters?.[asOfDateKey]).toDate()
      : new Date()
  );
  const { t } = useTranslation();
  const [customDateRange, setCustomDateRange] = useState<TDatePickerVal>({
    startDate: dayjs(filters?.[startDateKey]).isValid()
      ? dayjs(filters?.[startDateKey]).toDate()
      : new Date(),
    endDate: dayjs(filters?.[endDateKey]).isValid()
      ? dayjs(filters?.[endDateKey]).toDate()
      : new Date(),
    key: "selection",
  });

  const anchorRef = useRef<HTMLDivElement | null>(null);
  const dateSelectRef = useRef<HTMLDivElement>(null);
  const chipDateSelectRef = useRef<HTMLDivElement>(null);

  const handleCloseDatePopper = () => {
    anchorRef.current = null;
    setOpen(false);
  };

  /**
   * Wraps `onDateFilterChange` to strip date-related keys when
   * `showDateFilter` is false, guaranteeing they never reach the API.
   * Defined before `renderFilter` to avoid temporal dead zone errors.
   */
  const safeOnDateFilterChange = (data: any) => {
    if (!onDateFilterChange) return;

    let processedData = { ...data };

    // Map internal keys to filterKeys if they exist and are different
    if (data.hasOwnProperty('start_date') && filterKeys?.start_date) {
      processedData[filterKeys.start_date] = data.start_date;
      if (filterKeys.start_date !== 'start_date') delete processedData.start_date;
    }
    if (data.hasOwnProperty('end_date') && filterKeys?.end_date) {
      processedData[filterKeys.end_date] = data.end_date;
      if (filterKeys.end_date !== 'end_date') delete processedData.end_date;
    }
    if (data.hasOwnProperty('as_of_date') && filterKeys?.as_of_date) {
      processedData[filterKeys.as_of_date] = data.as_of_date;
      if (filterKeys.as_of_date !== 'as_of_date') delete processedData.as_of_date;
    }

    if (showDateFilter) {
      onDateFilterChange(processedData);
    } else {
      // Strip all date fields (including mapped ones) so they cannot pollute the request payload.
      const keysToStrip = [
        'start_date', 'end_date', 'as_of_date',
        filterKeys?.start_date, filterKeys?.end_date, filterKeys?.as_of_date
      ].filter(Boolean);

      const rest = { ...processedData };
      keysToStrip.forEach(key => delete rest[key]);

      onDateFilterChange(rest);
    }
  };

  const handleDateChange = async (range: keyof typeof RANGE) => {
    // Do nothing if the date filter is hidden — guard against programmatic calls.
    if (!showDateFilter) return;
    setDateRange(range);
    if (range === "CUSTOM") {
      anchorRef.current = dateSelectRef.current;
      setOpen(true);
    } else {
      const data = await handleCompareDateRange({
        range: RANGE[range],
        from: "",
        to: "",
      });
      safeOnDateFilterChange({
        start_date: data?.from ? data?.from : "",
        end_date: data?.to ? data?.to : "",
      });
      handleCloseDatePopper();
    }
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    handleCloseDatePopper();
  };
  const handleSelectChange = (value: any) => {
    if (selectedItems.some((item) => item.value == value.value)) {
      setSelectedItems(selectedItems.filter((item) => item?.value != value.value));
      const filterKey = value.value || value.key;
      const valueKey = filterKeys?.[filterKey] || filterKey;
      safeOnDateFilterChange({ [valueKey]: value.multiple ? [] : null })
      return;
    }
    setSelectedItems([...selectedItems, value]);
  };
  // Create filters config from filterDropDown and filterKeys
  // If reportFilters is needed, it should be provided by the consuming application
  const filtersConfig = filterDropDown?.map((filter: any) => ({
    key: filter.value || filter.key,
    label: filter.name || filter.label || `Search ${filter.value || filter.key}`,
    placeholder: filter.placeholder || filter.name || filter.label,
    apiType: filter.options ? undefined : (filter.apiType || filter.value || filter.key),
    valueKey: filterKeys?.[filter.value || filter.key] || filter.value || filter.key,
    customFilter: filter.customFilter || null,
    multiple: filter.multiple || false,
    options: filter.options || undefined,
  })) || []

  /** A filter is "applied" when its value in the `filters` prop is non-empty. */
  const isFilterApplied = (val: any) =>
    Array.isArray(val) ? val.length > 0 : val !== undefined && val !== null && val !== '';

  // Filters the user has toggled on via the "Filter" checklist. These are the
  // dropdowns shown inside the Applied Filters menu so their value can be set.
  const selectedFilters = filtersConfig.filter((config: any) =>
    showFilter(config.key)
  );
  const selectedFilterCount = selectedFilters.length;

  // Filters (from `filtersConfig`) that currently hold a real value in `filters`.
  const appliedFilterCount = filtersConfig.filter((config: any) =>
    isFilterApplied(filters?.[config.valueKey])
  ).length;

  // Close the applied-filters popover once no filters are selected, so it
  // doesn't stay anchored to the (now unmounted) button.
  useEffect(() => {
    if (selectedFilterCount === 0 && appliedFiltersAnchorEl) {
      setAppliedFiltersAnchorEl(null);
    }
  }, [selectedFilterCount, appliedFiltersAnchorEl]);

  useEffect(() => {
    if (!autoShowFiltersWithValue) return;
    setSelectedItems((prev) => {
      const visibleKeys = new Set(prev.map(item => item?.value));
      let changed = false;
      const next = [...prev];
      filtersConfig.forEach((config: any) => {
        if (visibleKeys.has(config.key)) return;
        const val = filters?.[config.valueKey];
        const hasValue = Array.isArray(val) ? val.length > 0 : (val !== undefined && val !== null && val !== '');
        if (hasValue) {
          next.push({ value: config.key });
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [filters, filtersConfig, autoShowFiltersWithValue]);

  const options = [
    {
      label: RANGE.TODAY,
      callback: () => {
        handleDateChange("TODAY");
      },
    },
    {
      label: RANGE.THIS_WEEK,
      callback: () => {
        handleDateChange("THIS_WEEK");
      },
    },
    {
      label: RANGE.THIS_MONTH,
      callback: () => {
        handleDateChange("THIS_MONTH");
      },
    },
    {
      label: RANGE.THIS_QUARTER,
      callback: () => {
        handleDateChange("THIS_QUARTER");
      },
    },
    {
      label: RANGE.THIS_YEAR,
      callback: () => {
        handleDateChange("THIS_YEAR");
      },
    },
    {
      label: RANGE.YESTERDAY,
      callback: () => {
        handleDateChange("YESTERDAY");
      },
    },
    {
      label: RANGE.PREVIOUS_WEEK,
      callback: () => {
        handleDateChange("PREVIOUS_WEEK");
      },
    },
    {
      label: RANGE.PREVIOUS_MONTH,
      callback: () => {
        handleDateChange("PREVIOUS_MONTH");
      },
    },
    {
      label: RANGE.PREVIOUS_QUARTER,
      callback: () => {
        handleDateChange("PREVIOUS_QUARTER");
      },
    },
    {
      label: RANGE.PREVIOUS_YEAR,
      callback: () => {
        handleDateChange("PREVIOUS_YEAR");
      },
    },
    {
      label: RANGE.CUSTOM,
      callback: () => {
        handleDateChange("CUSTOM");
      },
    },
  ];

  const isChecked = (value: any) => {
    return selectedItems.some(item => item?.value == value?.value)
  }

  const handleFilterPopperSubmit = () => {
    const dateRangeFilter = {
      start_date: dayjs(customDateRange.startDate).format("YYYY-MM-DD"),
      end_date: dayjs(customDateRange.endDate).format("YYYY-MM-DD"),
    };
    const dateFilter = {
      as_of_date: dayjs(customDate).format("YYYY-MM-DD"),
    };

    // Use safeOnDateFilterChange so date keys are stripped when showDateFilter is false.
    safeOnDateFilterChange({
      ...(isDateRange ? dateRangeFilter : dateFilter),
    });
    handleCloseDatePopper();
  };
  function showFilter(val) {
    return selectedItems.some(item => item?.value == val)
  }

  const getStartAndEndDate = (filters: any) => {
    const startDate = dayjs(filters?.[startDateKey]).isValid() ? dayjs(filters[startDateKey]).toDate() : new Date();
    const endDate = dayjs(filters?.[endDateKey]).isValid() ? dayjs(filters[endDateKey]).toDate() : new Date();
    return { startDate, endDate };
  };

  useEffect(() => {
    if (filters?.[asOfDateKey]) {
      setCustomDate(
        dayjs(filters?.[asOfDateKey]).isValid()
          ? dayjs(filters?.[asOfDateKey]).toDate()
          : new Date()
      );
    }
  }, [filters?.[asOfDateKey], asOfDateKey]);

  useEffect(() => {
    setCustomDateRange({
      ...customDateRange,
      ...getStartAndEndDate(filters)
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.[endDateKey], filters?.[startDateKey]]);

  useEffect(() => {
    if (open) {
      if (isDateRange) {
        setCustomDateRange({
          ...customDateRange,
          ...getStartAndEndDate(filters)
        });
      } else {
        setCustomDate(
          dayjs(filters?.[asOfDateKey]).isValid()
            ? dayjs(filters?.[asOfDateKey]).toDate()
            : new Date()
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isDateRange]);

  useEffect(() => {
    dispatch(fetchCompanies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setAllFields(generateFields(reportFilterFields));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    handleDateChange(dateFilter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFilter]);

  const filterDropDownFunc = () => {
    return (
      <Menu
        anchorEl={actionAnchorEl}
        open={Boolean(actionAnchorEl)}
        onClose={handleFilterClose}
      >
        {/* <MenuItem className="inventoryReportsTitleBar--report-filter"> */}
        {/* Add your options here */}
        {filterDropDown?.map((item) => (
          <MenuItem onClick={() => handleSelectChange(item)} key={item} value={item?.value}>
            <Checkbox checked={isChecked(item)} />
            <Typography sx={{ marginLeft: '10px' }} color='theme.neutral.800' type='s3'>{t(item?.name)}</Typography>
          </MenuItem>
        ))}
        {/* </MenuItem> */}
      </Menu>
    );
  };

  const renderFilter = ({
    key,
    label,
    placeholder,
    apiType,
    valueKey,
    customFilter,
    multiple = false,
    options,
    show = true,
    showCancelButton = true,
    forceShow = false
  }: any) => {
    if ((!showFilter(key) && !forceShow) || !show) return null;

    const companyKey = filterKeys?.company || 'company';
    const companyId = filters?.[companyKey];
    const hasCompany = Array.isArray(companyId) ? companyId.length > 0 : !!companyId;

    let finalCustomFilter = customFilter;
    if (['department', 'designation', 'location', 'employees'].includes(apiType) && hasCompany) {
      finalCustomFilter = {
        ...(typeof customFilter === 'object' ? customFilter : {}),
        '&company_id.in': hasCompany ? (Array.isArray(companyId) ? companyId.join(',') : companyId) : null
      };
    }

    return (
      <SearchableSelect
        labelId={`${key}-label`}
        searchPlaceholder={t(label)}
        value={filters?.[valueKey]}
        onChange={(e) => safeOnDateFilterChange({ [valueKey]: e.target.value })}
        showCancelButton={showCancelButton}
        apiType={apiType}
        isInternal={!apiType && !!options}
        options={options}
        multiple={multiple}
        placeholder={t(placeholder)}
        customeFilter={finalCustomFilter}
        customStyle={customStyle}
        inputStyle={inputStyle}
      />
    );
  };

  const handleFilterClose = () => {
    setActionAnchorEl(null);
  };
  const handleAppliedFilterClose = () => {
    setAppliedFiltersAnchorEl(null);
  };

  const ExportContainer = React.memo(() => {
    const handleClose = () => setExportAnchorEl(null);
    return (
      <Menu
        open={Boolean(exportAnchorEl)}
        anchorEl={exportAnchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {dropdownMenuButtonData?.options?.map((option, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              option.callback();
              setExportAnchorEl(null);
            }}
          >
            <Typography type="s4" weight="medium" color={'inherit'}> {option.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    )
  })

  return (
    <div>
      <div className="reportsTitleBar">
        <div className="reportsTitleBar--LeftContent">
          {isTitleMenu ? (
            <div style={{ zIndex: 999 }}>
              <TitleDropdownButton
                onClick={handleAddButton}
                options={titleMenus}
                isMenuThirdItemDisabled={true}
              >
                {title}
              </TitleDropdownButton>
            </div>
          ) : (
            <Typography type="h3" weight="medium" color="theme.secondary.1000">
              {title}
            </Typography>
          )}
        </div>

        {searchBar && (
          <div className="reportsTitleBar--SearchBar">
            {searchBar}
          </div>
        )}
        <div className="reportsTitleBar--RightContent">
          {showDateFilter && isDateRange && (filters?.[endDateKey]) && (
            <div style={{ display: "flex", gap: "8px" }}>
              <div
                className="reportsTitleBar--FilterWrapper--Chip"
                ref={chipDateSelectRef}
                onClick={() => {
                  if (!open) {
                    anchorRef.current = chipDateSelectRef.current;
                    setOpen(true);
                  } else {
                    handleCloseDatePopper();
                  }
                }}
              >
                <div
                  className="reportsTitleBar--FilterWrapper--Chip--Text"
                  title={`${dayjs(filters?.[startDateKey]).format("DD/MM/YYYY")} - ${dayjs(filters?.[endDateKey]).format("DD/MM/YYYY")}`}
                >
                  <Typography type="s4" weight="medium">
                    {t("common.dateRange")}:
                  </Typography>
                  <Typography
                    className="reportsTitleBar--FilterWrapper--Chip--Text--Value"
                    type="s4"
                  >
                    {dayjs(filters?.[startDateKey]).format("DD/MM/YYYY")} -{" "}
                    {dayjs(filters?.[endDateKey]).format("DD/MM/YYYY")}
                  </Typography>
                </div>
                <KeyboardArrowDownIcon />
              </div>
            </div>
          )}
          {showDateFilter && !isDateRange && isDateFilterEnabled && !['TODAY', 'YESTERDAY'].includes(dateRange) && (
            <>
              {customDateRange?.startDate && (
                <div style={{ display: "flex", gap: "8px" }}>
                  <div
                    className="reportsTitleBar--FilterWrapper--Chip"
                    style={{ padding: ' 5px 12px' }}
                  >
                    <div
                      className="reportsTitleBar--FilterWrapper--Chip--Text"
                      title={`${dayjs(customDateRange?.startDate).format("DD/MM/YYYY")}`}
                    >
                      <Typography type="s4" weight="medium">
                        {t("common.startDate")}:
                      </Typography>
                      <Typography
                        className="reportsTitleBar--FilterWrapper--Chip--Text--Value"
                        type="s4"
                      >
                        {dayjs(customDateRange?.startDate).format("DD/MM/YYYY")}
                      </Typography>
                    </div>
                  </div>
                </div>
              )}
              {customDateRange?.endDate && (
                <div style={{ display: "flex", gap: "8px" }}>
                  <div
                    className="reportsTitleBar--FilterWrapper--Chip"
                    style={{ padding: ' 5px 12px' }}
                  >
                    <div
                      className="reportsTitleBar--FilterWrapper--Chip--Text"
                      title={`${dayjs(customDateRange?.endDate).format("DD/MM/YYYY")}`}
                    >
                      <Typography type="s4" weight="medium">
                        {t("common.endDate")}:
                      </Typography>
                      <Typography
                        className="reportsTitleBar--FilterWrapper--Chip--Text--Value"
                        type="s4"
                      >
                        {dayjs(customDateRange?.endDate).format("DD/MM/YYYY")}
                      </Typography>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          {showDateFilter && filters?.[asOfDateKey] && !isDateRange && (
            <div style={{ display: "flex", gap: "8px" }}>
              <div
                className="reportsTitleBar--FilterWrapper--Chip"
                ref={chipDateSelectRef}
                onClick={() => {
                  if (!open) {
                    anchorRef.current = chipDateSelectRef.current;
                    setOpen(true);
                  } else {
                    handleCloseDatePopper();
                  }
                }}
              >
                <div
                  className="reportsTitleBar--FilterWrapper--Chip--Text"
                  title={`${dayjs(filters?.[asOfDateKey]).format("DD/MM/YYYY")}`}
                >
                  <Typography type="s4" weight="medium">
                    {t("common.date")}:
                  </Typography>
                  <Typography
                    className="reportsTitleBar--FilterWrapper--Chip--Text--Value"
                    type="s4"
                  >
                    {dayjs(filters?.[asOfDateKey]).format("DD/MM/YYYY")}
                  </Typography>
                </div>
                <KeyboardArrowDownIcon />
              </div>
            </div>
          )}

          <div className="report-display">
            {dropdownMenuButtonData?.options?.length > 0 &&
              <Box>
                <Button
                  sx={({ palette }) => ({
                    border: "1px solid",
                    borderColor: 'grey.200',
                    borderRadius: "50px",
                    color: `${palette.grey[800]} !important`,
                    '&:hover': {
                      bgcolor: `${palette.grey[200]} !important`,
                    }
                  })}
                  variant="text"
                  startIcon={<ExportIcon fontSize="small" />}
                  onClick={(event) => setExportAnchorEl(event.currentTarget)}
                >
                  {t("common.export")}
                </Button>
                {exportAnchorEl && (
                  <ExportContainer />
                )}
              </Box>
            }

            {filterDropDown?.length &&
              <>
                <Box>
                  <Button
                    sx={({ palette }) => ({
                      border: "1px solid",
                      borderColor: 'grey.200',
                      borderRadius: "50px",
                      color: `${palette.grey[800]} !important`,
                      '&:hover': {
                        bgcolor: `${palette.grey[200]} !important`,
                      }
                    })}
                    variant="text"
                    startIcon={<FilterIcon fontSize="small" />}
                    onClick={(event) => setActionAnchorEl(event.currentTarget)}
                  >
                    {t("common.filter")}
                  </Button>
                </Box>
                {showLevelBtn && <Divider flexItem orientation="vertical" sx={{ height: '50%', alignSelf: 'auto' }} />}

                {selectedFilterCount > 0 && (
                  <Button
                    sx={({ palette }) => ({
                      border: "1px solid",
                      borderColor: 'grey.200',
                      borderRadius: "50px",
                      color: `${palette.grey[800]} !important`,
                      '&:hover': {
                        bgcolor: `${palette.grey[200]} !important`,
                      }
                    })}
                    variant="text"
                    startIcon={<FilterIcon fontSize="small" />}
                    endIcon={
                      appliedFilterCount > 0 ? (
                        <Box
                          component="span"
                          sx={({ palette }) => ({
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: 20,
                            height: 20,
                            px: 0.75,
                            borderRadius: "10px",
                            fontSize: `12px !important`,
                            fontWeight: 600,
                            lineHeight: 1,
                            color: palette.common.white,
                            bgcolor: palette.primary.main,
                          })}
                        >
                          {appliedFilterCount}
                        </Box>
                      ) : null
                    }
                    onClick={(event) => setAppliedFiltersAnchorEl(event.currentTarget)}
                  >
                    {t("common.appliedFilters", "Applied Filters")}
                  </Button>
                )}
              </>
            }

            {filterDropDownFunc()}
            {showLevelBtn && (
              <>
                <Box className="reportsTitleBar--FilterAction--lvWrapper" >
                  <Typography type="s3" weight="medium" color='grey.800'> Level {level} of {dataLength}</Typography>
                  <ButtonGroup variant="outlined" disableElevation sx={({ palette }) => ({
                    '& .MuiButton-root': {
                      borderColor: `${palette.grey[200]} !important`,
                      '&:hover': {
                        bgcolor: `${palette.grey[200]} !important`,
                      }
                    },
                    '& .MuiButtonGroup-firstButton': {
                      borderTopLeftRadius: 20,
                      borderBottomLeftRadius: 20
                    },
                    '& .MuiButtonGroup-lastButton': {
                      borderTopRightRadius: 20,
                      borderBottomRightRadius: 20
                    }
                  })}>
                    <MuiButton onClick={() => {
                      setLevel(level == dataLength ? level : level + 1)
                      handleRowsCollapse?.(level)
                    }}>
                      <img src={images.common.expand} />
                    </MuiButton>
                    <MuiButton onClick={() => {
                      setLevel(level != 1 ? level - 1 : 1)
                      handleRowsExpand?.(level)
                    }}>
                      <img src={images.common.collapse} />
                    </MuiButton>
                  </ButtonGroup>
                </Box>
                {isDateFilterEnabled && <Divider flexItem orientation="vertical" sx={{ height: '50%', alignSelf: 'auto' }} />}
              </>
            )}
            {/* Date-range dropdown button — only shown when both isDateFilterEnabled AND showDateFilter are true */}
            {isDateFilterEnabled && showDateFilter && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography type="s3" weight="medium" color='grey.800'>As of: </Typography>
                <ReportButtons
                  zIndex={997}
                  className="reportsTitleBar--RightContent"
                  dropdownMenuButtonData={{
                    icon: <CalendarIcon fontSize="small" />,
                    children: (
                      <>
                        {RANGE[dateRange]}
                        <KeyboardArrowDownIcon />
                      </>
                    ),
                    options: options,
                  }}
                  toggleCallback={toggleCallback}
                />
                <div ref={dateSelectRef}></div>
              </Box>
            )}
          </div>

          <ReportButtons
            zIndex={999}
            buttons={buttons}
          />
        </div>
      </div>
      {tabs?.length ? (
        <div>
          <TabBar
            tabs={tabs || []}
            activeValue={activeValue}
            setActiveValue={setActiveValue}
            isTabViewOnly={true}
          />
        </div>
      ) : null}
      {/* <Filter
        open={openFilterPopup}
        onClose={() => setOpenFilterPopup(false)}
        fields={allFields}
        onSelectedFilter={(filterName: string) => console.log(filterName)}
        // getFilterStatesOnApply={() => {}}
        applyFilter={(val: any) => console.log('val', val)}
      /> */}

      <Popper
        sx={{
          zIndex: 9999,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              margin: "0 20px 0 20px",
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <div>
                    {isDateRange ? (
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => setCustomDateRange(item.selection)}
                        moveRangeOnFirstSelection={false}
                        ranges={[customDateRange]}
                        locale={enUS}
                      />
                    ) : (
                      <Calendar
                        onChange={(item) => setCustomDate(item)}
                        date={customDate}
                        locale={enUS}
                      />
                    )}
                  </div>
                  <Box sx={{ padding: "0 12px 12px 0" }}>
                    <Button
                      variant="contained"
                      sx={{ width: "fit-content" }}
                      onClick={handleFilterPopperSubmit}
                    >
                      {t("common.apply")}
                    </Button>
                  </Box>
                </Box>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <Popover
        anchorEl={appliedFiltersAnchorEl}
        open={Boolean(appliedFiltersAnchorEl)}
        onClose={handleAppliedFilterClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              minWidth: 280,
              maxWidth: 340,
              borderRadius: 2,
              overflow: "hidden",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
            },
          },
        }}
      >
        {(() => {
          // Show every selected filter so its value can be set/edited here.
          const hasContent =
            selectedFilters.length > 0 || customFilterComponents.length > 0;

          return (
            <>
              <Box
                sx={{
                  px: 2,
                  py: 1.5,
                  borderBottom: "1px solid",
                  borderColor: "grey.200",
                  bgcolor: "grey.50",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography type="s3" weight="medium" color="grey.800">
                  {t("common.appliedFilters", "Applied Filters")}
                </Typography>
                {appliedFilterCount > 0 && (
                  <Box
                    component="span"
                    sx={({ palette }) => ({
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: 20,
                      height: 20,
                      px: 0.75,
                      borderRadius: "10px",
                      fontSize: '12px !important',
                      fontWeight: 600,
                      lineHeight: 1,
                      color: palette.common.white,
                      bgcolor: palette.primary.main,
                    })}
                  >
                    {appliedFilterCount}
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  p: 2,
                  maxHeight: 380,
                  overflowY: "auto",
                }}
              >
                {hasContent ? (
                  <>
                    {selectedFilters.map((config: any) => (
                      <Box
                        key={config.key}
                        sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}
                      >
                        <Typography type="s4" weight="medium" color="grey.700">
                          {t(config.label)}
                        </Typography>
                        {renderFilter(config)}
                      </Box>
                    ))}
                    {customFilterComponents.map(({ key, component }) => (
                      <Box key={key}>{component}</Box>
                    ))}
                  </>
                ) : (
                  <Typography type="s4" color="grey.500">
                    {t("common.noFiltersApplied", "No filters applied")}
                  </Typography>
                )}
              </Box>
            </>
          );
        })()}
      </Popover>

    </div>
  );
};

export { ReportsTitleBar };
export default ReportsTitleBar;
